import { render, staticRenderFns } from "./PtSettingsDrawer.vue?vue&type=template&id=49a61467&scoped=true"
import script from "./PtSettingsDrawer.vue?vue&type=script&lang=js"
export * from "./PtSettingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./PtSettingsDrawer.vue?vue&type=style&index=0&id=49a61467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a61467",
  null
  
)

export default component.exports